var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.478 7.88756H12.8425C12.5017 7.88774 12.1832 7.71866 11.9924 7.43637L10.5568 5.32092C10.3653 5.03981 10.0468 4.87195 9.70671 4.87281H5.12202C3.98937 4.87281 3.07117 5.79101 3.07117 6.92366V19.2288C3.07117 20.3614 3.98937 21.2796 5.12202 21.2796H19.478C20.6107 21.2796 21.5289 20.3614 21.5289 19.2288V9.93842C21.5289 8.80576 20.6107 7.88756 19.478 7.88756Z",
    stroke: "#F4904D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07117 10.9023H9.7067C10.0458 10.9022 10.3628 10.7344 10.5537 10.4542L11.9893 8.33671C12.1802 8.05581 12.4977 7.88762 12.8373 7.88757",
    stroke: "#F4904D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.ee815338edc52aa11d68f4ee2954ee9e.svg";
export { ForwardRef as ReactComponent };